import React from 'react';
import { FlameIcon, GiftIcon, WalletIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-mist" data-id="element-27" data-mp="vt6380lprcok">
      <div className="mx-auto max-w-letter px-4 py-7 text-center sm:px-6 sm:py-8" data-id="element-28" data-mp="vqjlj853zgsm">
        <h2 id="bonos" className="font-display text-xl uppercase leading-[1.1] tracking-tight text-brand-dark sm:text-3xl" data-id="element-29" data-mp="qsi2uoblhjho">
          5 Bonos incluidos
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-sm font-semibold leading-snug text-ink-muted" data-id="element-30" data-mp="zu7tvt1kegex">
          Y además recibís 5 recursos prácticos — GRATIS con tu compra.
        </p>

        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-31" data-mp="19llygf8di6ex">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-lg border-2 border-gold bg-white p-3.5 text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-32" data-mp="1nkvg7jc898l0" data-mpi={i}>
              <p className="flex items-center gap-1.5 text-[0.62rem] font-extrabold uppercase tracking-[0.12em] text-gold-dark" data-id="element-33" data-mp="3tsfdyqx2xdz2">
                <GiftIcon size={13} aria-hidden="true" data-id="element-34" data-mp="2nyuq081np7l" />
                Bono {i + 1} — Gratis
              </p>
              <h3 className="mt-1 text-[0.82rem] font-extrabold uppercase leading-tight tracking-tight text-brand-dark" data-id="element-35" data-mp="cjs81ltl7mqf">
                {bono.title}
              </h3>
              <p className="mt-1 text-[0.8rem] font-medium leading-snug text-ink-muted sm:text-sm" data-id="element-36" data-mp="gjkdvqrljes3">
                {bono.desc}
              </p>
              <p className="mt-auto pt-2 text-[0.72rem] font-extrabold uppercase tracking-wide text-brand" data-id="element-37" data-mp="qbq691lrfy7t">
                Valor: {bono.value}
              </p>
            </Reveal>)}
        </ul>

        <Reveal className="mt-3 rounded-lg bg-brand-dark px-4 py-3" data-id="element-38" data-mp="108l5xntrs4no">
          <p className="flex items-center justify-center gap-1.5 text-[0.72rem] font-extrabold uppercase tracking-[0.1em] text-gold sm:text-xs" data-id="element-39" data-mp="al8o71sm43fw">
            <WalletIcon size={14} aria-hidden="true" data-id="element-40" data-mp="5ngvi5k58dan" />
            Valor total de los 5 bonos:
          </p>
          <p className="font-display text-3xl leading-none text-white line-through decoration-alert decoration-[3px] sm:text-4xl" data-id="element-41" data-mp="kclevq2ocnkc">
            {BONUS_TOTAL}
          </p>
          <p className="mt-1.5 flex items-center justify-center gap-1.5 text-[0.78rem] font-extrabold uppercase tracking-tight text-white sm:text-sm" data-id="element-42" data-mp="taxg0m1633r1">
            <FlameIcon size={14} className="text-gold" aria-hidden="true" data-id="element-43" data-mp="oeq5sh1qn63a" />
            Hoy los 5 están incluidos gratis.
          </p>
        </Reveal>
      </div>
    </section>;
}